<template>
  <v-content v-if="loading">
    <breadcrumbs></breadcrumbs>
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <v-row class="rows center-style">
      <v-flex class="product">
        <v-flex class="product-title">
          {{product.productName}}
        </v-flex>
        <editor v-html="product.productContent"></editor>
      </v-flex>

      <!-- 右部· -->
      <v-flex class="others">

        <!-- 最新热点 -->
        <v-flex class="div-title">
          <v-flex class="title-text">最新热点</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <v-row style="margin-top:10px"
                 class="re-dian"
                 v-for="(item,i) in productList"
                 :key="'0'+i">
            <v-flex class="re-dian-image">
              <img class="image"
                   @click="getProduct(item.productId)"
                   :src="item.photo" />
            </v-flex>
            <v-flex class="re-dian-title">
              {{item.productName}}
            </v-flex>
          </v-row>
        </v-flex>

        <!-- 关于我们 -->
        <v-flex class="div-title">
          <v-flex class="title-text">关于我们</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <v-flex>
            <img class="image"
                 @click="$router.push({ name: 'CompanyProfile' })"
                 src="@/images/text/aboutUs.jpg" />
          </v-flex>

        </v-flex>

        <!-- 新闻动态-->
        <v-flex class="div-title">
          <v-flex class="title-text">新闻动态</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <v-flex>
            <img class="image"
                 @click="$router.push({ name: 'News' })"
                 src="@/images/text/news.jpg" />
          </v-flex>

        </v-flex>

      </v-flex>
    </v-row>
  </v-content>
</template>
<script>

import Loading from '@/components/core/Loading' //引入产品列表分页 api 接口

export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      isLoading: false,
      //产品列表
      productList: [],
      //产品
      product: {}
    }
  },
  mounted () {
    this.$emit("updateToolbarValue", 3)
  },
  created () {
    this.productList = this.$route.query.productList;
    this.init();
  },
  methods: {
    //初期化
    init () {
      this.getProduct(this.$route.query.productId);
      this.loading = true;
    },

    getProduct (id) {
      this.isLoading = true;
      this.$store
        .dispatch("GetProductById", id)
        .then(response => {
          this.product = response.data.data;
          this.isLoading = false;
        })
        .catch(() => { });
    },

  }
}
</script>

<style scoped>
.rows {
  margin: 70px 0 0 0;
}
.center-style {
  display: flex;
  justify-content: center;
  align-content: center;
}

.product {
  width: 50%;
  max-width: 600px;
  flex: none;
}

.product-title {
  text-align: center;
  font-size: 25px;
  margin-bottom: 10px;
}
.image {
  width: 100%;
  height: 100%;
}

.others {
  width: 400px;
  flex: none;
}
.blue-divider {
  width: 30px;
  border: 2px solid #42a5f6 !important;
  margin: 3px 0 20px 0;
}
.div-title {
  margin-top: 20px;
  padding: 20px;
}
.title-text {
  font-size: 20px;
}
.product-content {
  margin: 10px;
  font-size: 14px;
  color: gray;
}
.re-dian {
  margin: 0;
  height: 80px;
  flex: none;
}
.re-dian-image {
  width: 110px;
  height: 80px;
}
.re-dian-title {
  width: calc(100% - 120px);
  margin-left: 10px;
  font-size: 14px;
  color: gray;
  overflow: hidden;
}
</style>